<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">{{ options.title | translate }}</p>
  </div>
  <div class="modal-body">
    <div class="row">
      <div [innerHtml]="options.message | translate"></div>
    </div>
  </div>
  <div class="modal-footer py-2">
    <button
      ngbAutoFocus
      type="button"
      class="btn btn-primary me-2"
      [disabled]="closing"
      (click)="yes()"
    >
      {{ 'common.yes' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-clear"
      [disabled]="closing"
      (click)="no()"
    >
      {{ 'common.no' | translate }}
    </button>
  </div>
</div>
